/**
 * Diccionario ESPAÑOL -> INGLÉS de las cadenas envueltas con `t(...)` en los componentes de esta
 * tanda (CrearModal, Puente, Referidos, MenuWallet, SelectorRed, BotonAyuda, DexSoportadas).
 *
 * La clave es la cadena en español EXACTA que aparece en el código; los `{x}` marcan lo que se
 * interpola y se conservan tal cual. No se traducen nombres propios (Keellabs, Uniswap, PRJX…),
 * símbolos de token, direcciones ni unidades.
 */
export const MISC: Record<string, string> = {
  // --- CrearModal ---
  "Abriendo la piscina": "Opening the pool",
  "Confírmalo en tu wallet: son varias firmas encadenadas.": "Confirm it in your wallet: it's several chained signatures.",
  "Tu piscina está abierta": "Your pool is open",
  "El dinero ya está en el rango y el robot la gestiona desde ahora.": "The funds are already in range and the robot manages it from now on.",
  "Cerrar": "Close",
  "Ver mi piscina": "View my pool",
  "Abrir una piscina": "Open a pool",
  "{pair} · comisión {fee}%": "{pair} · fee {fee}%",
  "Cuatro pasos. Puedes volver atrás en cualquiera.": "Four steps. You can go back on any of them.",
  "Cancelar": "Cancel",
  "← Atrás": "← Back",
  "Seguir →": "Continue →",
  "Abriendo…": "Opening…",
  "Abrir · {firmas} firmas": "Open · {firmas} signatures",
  "En qué": "What in",
  "Cuánto": "How much",
  "El rango": "The range",
  "Confirmar": "Confirm",
  "No pude leer las pools de {etiqueta}.": "Couldn't read the pools on {etiqueta}.",
  "Reintentar": "Retry",
  "Con qué token": "Which token",
  "usa lo que ya tengas": "use what you already have",
  "{symbol} · el estable": "{symbol} · the stable",
  "{symbol} · el activo": "{symbol} · the asset",
  "Cuánto inviertes": "How much you invest",
  "leyendo tu saldo…": "reading your balance…",
  "no pude leer tu saldo": "couldn't read your balance",
  "reintentar": "retry",
  "tienes {saldo} {symbol}": "you have {saldo} {symbol}",
  "MÁX": "MAX",
  "Bolsa de gas": "Gas pot",
  "opcional": "optional",
  "Una reserva en": "A reserve in",
  "que el robot gasta para pagar el gas de cada reajuste.": "that the robot spends to pay the gas of each rebalance.",
  "Lo que no gaste se te devuelve.": "Whatever it doesn't spend is returned to you.",
  "Si no lo tienes claro, déjala como está.": "If you're not sure, leave it as it is.",
  "Inviertes": "You invest",
  "Sale de tu wallet": "Leaves your wallet",
  "Te faltan {falta} {symbol} para cubrir la inversión más la bolsa de gas. Baja la cantidad o pulsa MÁX.": "You're {falta} {symbol} short to cover the investment plus the gas pot. Lower the amount or tap MAX.",
  "Precio ahora": "Price now",
  "{unidad} por {activo}": "{unidad} per {activo}",
  "actualizando": "updating",
  "Por porcentaje": "By percentage",
  "Precios exactos": "Exact prices",
  "Ancho": "Width",
  "±{pct}% alrededor del precio": "±{pct}% around the price",
  "Precio mínimo": "Minimum price",
  "en {unidad}": "in {unidad}",
  "Precio máximo": "Maximum price",
  "El máximo tiene que ser mayor que el mínimo.": "The maximum must be greater than the minimum.",
  "El contrato abre el rango": "The contract opens the range",
  "centrado en el precio de ahora": "centered on the current price",
  ": solo puede recibir un semiancho, no dos bordes sueltos. De lo que escribas se respeta el ancho, y abajo ves dónde queda de verdad.": ": it can only take one half-width, not two loose edges. The width you type is respected, and below you see where it really lands.",
  "Quedará en": "Will end up at",
  "Cobras mientras {activo} esté entre esos dos precios, en {unidad}. Más estrecho cobra más, pero se sale antes — y cada salida gasta de tu bolsa de gas.": "You earn while {activo} stays between those two prices, in {unidad}. Tighter earns more, but exits sooner — and each exit spends from your gas pot.",
  "Promediar a la baja": "Average down",
  "Aparta una parte y el robot la va soltando cuando el precio cae, para comprar más barato.": "Set some aside and the robot releases it as the price falls, to buy cheaper.",
  "Solo con el estable": "Only with the stable",
  ": la reserva vive en él.": ": the reserve lives in it.",
  "Reserva": "Reserve",
  "Cuándo soltarla": "When to release it",
  "En cada reajuste del rango": "On each range rebalance",
  "Cada vez que el precio cae otro tanto": "Every time the price drops by that much again",
  "Nunca — se queda quieta": "Never — it stays put",
  "Cuánto suelta": "How much it releases",
  "% de la reserva": "% of the reserve",
  "Por cada caída de": "For each drop of",
  "Con «nunca» la reserva se queda parada y no hace nada.": "With “never” the reserve sits still and does nothing.",
  "Reinvertir las ganancias en vez de apartarlas": "Reinvest the profits instead of setting them aside",
  "Trabajando en el rango": "Working in the range",
  "Apartado para promediar": "Set aside for averaging",
  "Comisión de Keellabs": "Keellabs fee",
  "10% de las ganancias": "10% of the profits",
  "Firmas en tu wallet": "Signatures in your wallet",
  "Tu dinero va a un vault que es": "Your money goes to a vault that is",
  "tuyo": "yours",
  ": el robot solo puede reajustar el rango, no sacarlo ni cambiar tus ajustes. Puedes retirarlo todo cuando quieras.": ": the robot can only rebalance the range, not withdraw it or change your settings. You can pull it all out whenever you want.",

  // --- Puente ---
  "Cambio hecho": "Swap done",
  "Enviado": "Sent",
  "Ya tienes el {symbol} en tu wallet.": "You already have the {symbol} in your wallet.",
  "token": "token",
  "El dinero llega a {cadena} en unos minutos.": "The funds arrive on {cadena} in a few minutes.",
  "Enviando": "Sending",
  "Es más de lo que tienes. Pulsa MÁX para usar el máximo exacto.": "That's more than you have. Tap MAX to use the exact maximum.",
  "Sin ruta para este par ahora mismo.": "No route for this pair right now.",
  "Suele ser porque el importe está por debajo del mínimo del puente: prueba con más.": "It's usually because the amount is below the bridge's minimum: try more.",
  "Prueba con otro token o con otro importe.": "Try another token or another amount.",
  "Bridge y Swap": "Bridge & Swap",
  "Junta lo que te ha quedado suelto en cualquier red y conviértelo a un estable. Keellabs cobra 0,05% del importe; lo que cobre el puente o el DEX ya viene descontado en lo que recibes. El gas de la red va aparte.": "Gather what's left loose on any network and convert it to a stablecoin. Keellabs charges 0.05% of the amount; whatever the bridge or DEX charges is already deducted from what you receive. Network gas is separate.",
  "Cambia y mueve dinero entre cadenas con la ruta más barata (Jumper/LI.FI). Comisión total 0,30% del importe: 0,25% de LI.FI + 0,05% de Keellabs. El gas de la red va aparte.": "Swap and move funds across chains via the cheapest route (Jumper/LI.FI). Total fee 0.30% of the amount: 0.25% LI.FI + 0.05% Keellabs. Network gas is separate.",
  "Origen y destino son la misma cadena: esto es un cambio de token, no un puente.": "Source and destination are the same chain: this is a token swap, not a bridge.",
  "Mueve dinero entre cadenas para poder invertirlo aquí. Keellabs cobra 0,10%.": "Move funds across chains so you can invest them here. Keellabs charges 0.10%.",
  "Traer dinero": "Bring funds",
  "Barrer restos": "Sweep leftovers",
  "Desde": "From",
  "Cambiar el sentido": "Swap the direction",
  "Hasta": "To",
  "Lo que tienes en {cadena}": "What you have on {cadena}",
  "leyendo…": "reading…",
  "No tienes ningún token en esa cadena. Cambia el origen arriba.": "You don't have any token on that chain. Change the source above.",
  "Envías": "You send",
  "Recibes": "You receive",
  "tienes {saldo}": "you have {saldo}",
  "Conecta tu wallet para ver saldos y cotizar.": "Connect your wallet to see balances and get a quote.",
  "Recibes al menos": "You receive at least",
  "Ruta": "Route",
  "Tarda": "Takes",
  "sin comisión": "no fee",
  "Firmas": "Signatures",
  "actualizando la ruta…": "updating the route…",
  "Enviando…": "Sending…",
  "Confirmar el envío": "Confirm the send",

  // --- Referidos ---
  "Estoy usando Keellabs para poner a trabajar mi dinero en piscinas de liquidez. Si entras por aquí, entras igual que yo:": "I'm using Keellabs to put my money to work in liquidity pools. If you join through here, you join just like me:",
  "← Volver": "← Back",
  "Invita y cobra": "Invite and earn",
  "Quien entre por tu enlace": "Whoever joins through your link",
  "paga exactamente lo mismo": "pays exactly the same",
  "que si hubiera entrado solo: el 10% de las comisiones que gane su piscina, nunca de su capital. Lo que se reparte es": "as if they'd joined on their own: 10% of the fees their pool earns, never of their capital. What's shared is",
  "nuestra": "our",
  "parte.": "share.",
  "para ti": "for you",
  "de las comisiones que genere tu invitado": "of the fees your invitee generates",
  "para Keellabs": "for Keellabs",
  "lo que antes era el 10% entero": "what used to be the full 10%",
  "le cuesta a él": "it costs them",
  "paga lo mismo, con invitación o sin ella": "they pay the same, with an invite or without one",
  "Tu enlace de invitación": "Your invitation link",
  "conecta tu wallet para verlo": "connect your wallet to see it",
  "Copiado ✓": "Copied ✓",
  "Copiar": "Copy",
  "Se cobra": "It's paid",
  "solo": "on its own",
  ": cada vez que la piscina de tu invitado cobra comisiones, tu parte sale en esa misma transacción y llega a tu wallet. No hay nada que reclamar.": ": each time your invitee's pool collects fees, your share goes out in that same transaction and reaches your wallet. There's nothing to claim.",
  "Eso sí": "That said",
  ": no empieza el primer día. Tu invitado tiene que haber generado un mínimo de comisiones antes de que el reparto se active — es lo que evita que alguien abra dos wallets y se invite a sí mismo.": ": it doesn't start on day one. Your invitee has to have generated a minimum of fees before the split kicks in — that's what stops someone opening two wallets and inviting themselves.",
  "En {etiqueta} el reparto": "On {etiqueta} the split",
  "todavía no está activo": "isn't active yet",
  ": el registro no está desplegado en esta red. Tu enlace ya funciona y las altas quedan guardadas, así que quien entre ahora cuenta cuando se encienda.": ": the registry isn't deployed on this network. Your link already works and sign-ups are saved, so whoever joins now counts when it goes live.",
  "Lo que llevas ganado": "What you've earned so far",
  "Contando…": "Counting…",
  "No pude leer tus números ahora mismo — reinténtalo en un momento. Tu enlace y el reparto no dependen de esto.": "Couldn't read your numbers right now — try again in a moment. Your link and the split don't depend on this.",
  "Invitados": "Invitees",
  "wallets que entraron por tu enlace": "wallets that joined through your link",
  "Ya te pagan": "Already paying you",
  "de {n} · pasaron el mínimo": "of {n} · passed the minimum",
  "cuando pasen el mínimo de comisiones": "once they pass the minimum of fees",
  "Aún no ha entrado nadie por tu enlace. Compártelo 👆 — cobras el": "Nobody has joined through your link yet. Share it 👆 — you earn",
  "de lo que generen sus piscinas, y a ellos no les cuesta nada.": "of what their pools generate, and it costs them nothing.",
  "Ya cobrado · en tu wallet": "Already paid · in your wallet",
  "Todavía nada cobrado. Se paga solo, en cuanto la piscina de un invitado cobre comisiones.": "Nothing paid yet. It pays out on its own as soon as an invitee's pool collects fees.",
  "Han generado tus invitados": "Your invitees have generated",
  "Tus invitados aún no han generado comisiones.": "Your invitees haven't generated fees yet.",
  "A ti te invitó": "You were invited by",
  " y ya está cobrando su parte de nuestra comisión.": " and is already earning their share of our fee.",
  ", y empezará a cobrar cuando tus piscinas hayan generado el mínimo.": ", and will start earning once your pools have generated the minimum.",
  "A ti no te cuesta nada: pagas lo mismo que pagarías sin él.": "It costs you nothing: you pay the same you'd pay without them.",
  "Invitación aceptada. A ti no te cambia nada: pagas la misma comisión de siempre.": "Invitation accepted. Nothing changes for you: you pay the same fee as always.",
  "Te invitó": "You were invited by",
  "Si lo aceptas, se lleva una parte de": "If you accept, they take a share of",
  "comisión cuando tus piscinas ganen —": "fee when your pools earn —",
  "tú pagas exactamente lo mismo": "you pay exactly the same",
  ", con invitación o sin ella.": ", with an invite or without one.",
  "Aceptar (solo una firma, sin gas)": "Accept (just one signature, no gas)",
  "No, gracias": "No, thanks",
  "aún nada": "nothing yet",
  "Tus invitados · {n} {palabra}": "Your invitees · {n} {palabra}",
  "wallet": "wallet",
  "wallets": "wallets",
  "{wallet} · copiar": "{wallet} · copy",
  "ya cuenta": "counts already",
  "pendiente": "pending",
  "Son las wallets que se dieron de alta con tu enlace. Toca una para copiarla.": "These are the wallets that signed up with your link. Tap one to copy it.",

  // --- MenuWallet ---
  "Conectada": "Connected",
  "Dirección copiada": "Address copied",
  "Copiar dirección": "Copy address",
  "Ver en el explorador": "View on the explorer",
  "Desconectar": "Disconnect",

  // --- SelectorRed ---
  "Cambiar de red": "Switch network",
  "Red no soportada": "Unsupported network",
  "Elegir red": "Choose network",
  "Red": "Network",

  // --- BotonAyuda ---
  "Documentación": "Documentation",
  "Cómo funciona la plataforma, en detalle.": "How the platform works, in detail.",
  "Aprende": "Learn",
  "Los conceptos y flujos básicos, explicados.": "The basic concepts and flows, explained.",
  "Únete al canal y pregunta a la comunidad.": "Join the channel and ask the community.",
  "Ayuda": "Help",
  "¿Necesitas ayuda?": "Need help?",
  "Nuestro equipo NUNCA te escribe por privado. Ignora y bloquea cualquier mensaje directo que recibas.": "Our team NEVER messages you privately. Ignore and block any direct message you receive.",

  "Registrados en cadena": "Registered on-chain",
  "los únicos que pueden llegar a pagarte": "the only ones who can end up paying you",
  "Todavía nada cobrado. Se paga solo, en cuanto la piscina de un invitado activo cobre comisiones.": "Nothing paid yet. It pays out on its own as soon as an active invitee's pool collects fees.",
  "Comisiones brutas de tus invitados · cuentan para su mínimo": "Your invitees' gross fees · count toward their minimum",
  "Tus invitados registrados aún no han generado comisiones.": "Your registered invitees haven't generated fees yet.",
  "Es lo que han ganado sus piscinas (antes de comisiones), medido en el estable de cada red. Cada invitado tiene que llegar al mínimo en una red para empezar a pagarte allí; a partir de ahí deja de sumarse aquí y tu parte llega sola.": "It's what their pools earned (before fees), measured in each network's stablecoin. Each invitee must reach the minimum on a network to start paying you there; from then on it stops adding up here and your share arrives on its own.",
  "activa · te paga": "active · pays you",
  "registrada · acumulando": "registered · accumulating",
  "no registrada en cadena": "not registered on-chain",
  "comprobando…": "checking…",
  "de mínimo": "of minimum",
  "{n} red(es) sin comisiones aún (mínimo {m} por red)": "{n} network(s) with no fees yet (minimum {m} per network)",
  "con otro referidor en: {redes}": "with another referrer on: {redes}",
  "te ha pagado": "has paid you",
  "registrada en {n} de {total} redes": "registered on {n} of {total} networks",
  "registrándose ahora mismo…": "registering right now…",
  "su firma caducó antes de subirse: que abra keellabs.app con su wallet y firme de nuevo (sin gas)": "their signature expired before it was uploaded: they need to open keellabs.app with their wallet and sign again (no gas)",
  "Estado leído de la cadena, red a red. Solo cuentan las registradas; toca una wallet para copiarla.": "Status read from the chain, network by network. Only registered ones count; tap a wallet to copy it.",
  "Hecho. Tu invitación se está registrando en la cadena; en un minuto debería verse como registrada.": "Done. Your invitation is being registered on-chain; it should show as registered within a minute.",
  "Tu invitación de {quien} no quedó registrada.": "Your invitation from {quien} wasn't registered.",
  "Firma de nuevo (sin gas) y la registramos en la cadena. A ti no te cuesta nada ni cambia tu comisión.": "Sign again (no gas) and we'll register it on-chain. It costs you nothing and doesn't change your fee.",
  "Falta en: {redes}.": "Missing on: {redes}.",
  "Firmar de nuevo (sin gas)": "Sign again (no gas)",
  "Llama a registrarPropio en el registro de {red}": "Calls registrarPropio on the {red} registry",
  "Registrarlo yo mismo en {red} (pagas el gas)": "Register it myself on {red} (you pay gas)",
  "Ahora no": "Not now",
  // --- DexSoportadas ---
  "Mercados soportados": "Supported markets",
  "DEX soportadas": "Supported DEXs",
  "Elige tu DEX. Tu dinero nunca sale de tu vault.": "Choose your DEX. Your money never leaves your vault.",
};
